import script from "./Address.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__